import { MinusCircleOutlined } from "@ant-design/icons";
import { Form, Select, Space } from "antd";
import Button from '../../../components/Button';
import { ChangeEvent, FC, useEffect, useState } from "react";
import { warningVariant } from '../../../lib/barVariant';
import { getKey } from "../../../lib/util";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

interface IProps {
  dummyOption: any;
  setDummyOption: any;
  maxPoints: any;
  setMaxPoints: any;
}

const PointInput: FC<IProps> = ({
  dummyOption,
  setDummyOption,
  maxPoints,
  setMaxPoints,
}) => {
  // const [data, setData] = useState<any>([]);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  
  const onChange = (e: any, key: number) => {
    setMaxPoints(
      maxPoints.map((item: any) => {
        if (item?.id === key) {
          return {
            ...item,
            pointBranchCode: e,
          };
        }
        return item;
      }),
    );
  };

  const hanldeMaxPointBlur = (
    e: ChangeEvent<HTMLInputElement>,
    key: number,
  ) => {
    setMaxPoints(
      maxPoints.map((item: any) => {
        if (item?.id === key) {
          return {
            ...item,
            maxPoint: Math.round(Number(e.target.value)),
          };
        }
        return item;
      }),
    );
  };

  useEffect(() => {
    if (dummyOption) {
      setDummyOption(
        dummyOption.map((item: any) => {
          if (
            maxPoints?.find(
              (element: any) => item.value === element.pointBranchCode,
            )
          ) {
            return {
              ...item,
              disabled: true,
            };
          }

          return {
            ...item,
            disabled: false,
          };
        }),
      );
    }
  }, [maxPoints]);

  return (
    <Form
      name="dynamic_form_nest_item"
      onFinish={() => console.log(1)}
      autoComplete="off"
    >
      <div className='comm-bx__between'>
        <h3 className='sub-title'>{t('program.point.2')}</h3>                
      </div>	
      <div className="comm-table__area">                 
        <table>
        <colgroup>
          <col style={{ width: '100%' }} />                     
        </colgroup>                    
        <tbody>
          {maxPoints.map((item: any) => {
            item.id = getKey();
            return (
              <tr>
                <td>
                  <div className='comm-gap'>
                    <Space
                      key={item.id}
                      style={{ display: 'flex' }}
                      align="baseline"
                    >
                      <Form.Item className="mb-0 text-left">
                        <Select
                          style={{ width: 200 }}
                          placeholder={t('common.button.select')}
                          onChange={(e) => onChange(e, item.id)}
                          options={dummyOption}
                          value={item?.pointBranchCode}
                        ></Select>
                      </Form.Item>
                      <Form.Item className="mb-0" rules={[{ required: true, message: 'Missing Score' }]}>
                        <input
                          type="number"
                          step={0}
                          className="form-control w-200p mr-1"
                          placeholder={t('common.column.score')}
                          defaultValue={item?.maxPoint}
                          onBlur={(e) => hanldeMaxPointBlur(e, item.id)}
                        />
                      </Form.Item>
                      <MinusCircleOutlined
                        onClick={() => {
                          setMaxPoints(
                            maxPoints.filter((_item: any) => item.id !== _item.id),
                          );
                        }}
                      />
                    </Space>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
        </table>
      </div> 
      <Form.Item  className="mb-0">
        <div className="comm-bx__space"> 
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink-line"
              onClick={() => {
                if (maxPoints.length >= dummyOption.length) {
                  enqueueSnackbar(t('program.point.message5'), warningVariant);
                  return;
                }
                setMaxPoints([...maxPoints, { id: getKey() }]);
              }}
              text={t('common.button.add')}
            />
          </div>
        </div>
      </Form.Item>
    </Form>
  );
};

export default PointInput;